<template>
  <div class="order-screen">
    <md-tabs class="md-transparent" @change="onChange" ref="tabs">
      <md-tab id="new-order" :md-active="activeTab === 0" :md-label="placeorder">
        <order-form :tabActive="activeTab"></order-form>
      </md-tab>

      <md-tab id="order-archive" :md-active="activeTab === 1" :md-label="pastorders">
        <order-archive></order-archive>
      </md-tab>
    </md-tabs>

  </div>
</template>

<script>
import Vue from 'vue'
import OrderForm from './Form'
import OrderArchive from './Archive'

export default {
  name: 'dashboard',
  data () {
    return {
      activeTab: 0
    }
  },
  updated () {
    this.onChange(this.activeTab)
  },
  computed: {
    placeorder () {
      return this.$gettext('Place Order')
    },
    pastorders () {
      return this.$gettext('Past Orders')
    }
  },
  methods: {
    onChange (value) {
      this.activeTab = value

      // looks like this solves the problem with TAB not being updated immediately after change of language
      Vue.nextTick(() => {
        this.$refs.tabs.$forceUpdate()
      })
    }
  },
  components: {
    OrderForm,
    OrderArchive
  }
}
</script>



// WEBPACK FOOTER //
// src/components/order/Dashboard.vue